import { BasePlugin } from '../base'
import mdcLayoutApp from './mdc-layout-app.vue'

export { mdcLayoutApp }

export default BasePlugin({
  mdcLayoutApp
})
